import axios from "axios";
import baseUrl from "./baseUrl";
import Qs from "qs";
import { Message, Loading } from "element-ui";
import Router from "@/router";
import layer from "vue-layer";
axios.defaults.baseURL = baseUrl;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

const codeList = [990, 991, 992, 993];

// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    config.headers.Authorization = localStorage["access_token"];
    config.loading = Loading.service({
      background: "rgba(0,0,0,.3)"
    });
    // 判断是云车场还是老系统车场
    if (Router.app._route.path.split("/")[2] != "yunMobile") {
      if (config.method === "post") {
        config.data = Qs.stringify(config.data);
      }
    }
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    console.log("返回处理", response);
    if (response.config.loading) {
      response.config.loading.close();
    }
    if (response.config.msg) {
      if (response.data.success) {
        Message.success(response.data.msg);
      } else {
        Message.error(response.data.error);
      }
      if (response.data.status == 500) {
        Message.error(response.data.message);
      }
    }
    if (codeList.findIndex(item => item == response.data.code) != -1) {
      Router.push("/login");
    }
    // 对响应数据做点什么
    return response;
  },
  function(error) {
    console.log("错误处理", error);
    // 对响应错误做点什么
    error.config.loading.close();
    return Promise.reject(error);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/config/axios.js